// extracted by mini-css-extract-plugin
module.exports = {"question":"Question_question__2_Jw6","answers":"Question_answers__1qc9i"};